import { hotjar } from 'react-hotjar';

const HOTJAR_ID = 845988;
const HOTJAR_SNIPPET_VERSION = 6;

export enum HotjarEvents {
  NEW_BANK_ACCOUNT_CREATED = 'bank_account_created',
  TRANSFER_REQUEST_MADE = 'transfer_request_made',
  NEW_STATEMENT_ACCESS = 'new_statement_access',
}

export function submitEvent(event: HotjarEvents) {
  hotjar.event(event);
}

export type HotjarUser = {
  id: number;
  email: string;
  name: string;
  isAccessControl: boolean;
  belt?: string;
};

export function setHotjarUser({ id, ...user }: HotjarUser) {
  hotjar.identify(String(id), user);
}

function main() {
  hotjar.initialize(HOTJAR_ID, HOTJAR_SNIPPET_VERSION);
}

main();
